const emoji1 = '/emoji/emoji1.webp';
const emoji2 = '/emoji/emoji2.webp';
const emoji3 = '/emoji/emoji3.webp';
const emoji4 = '/emoji/emoji4.webp';

export const emptyListImages = [emoji1, emoji2, emoji3, emoji4, emoji1];

export const PER_CHUNK_CONFIG = {
  desktopL: 25,
  desktop: 25,
  tablet: 20,
  mobile: 12,
  mobileS: 12,
};
